// The release version of the running build. It isn't compiled in: images are built
// once on main and promoted by retagging, so the version (e.g. v1.5.0) is set at
// release time as an image env var and written into config.js by `entrypoint.sh`.

function injected(value: string | undefined): string | undefined {
  return value && !value.startsWith('__VITE_') ? value : undefined
}

// The release version, or `dev-<commit>` for builds that were never released (dev, local).
export function appVersion(): string {
  const version = injected(globalThis.appConfig?.VITE_APP_VERSION)
  if (version) return version
  const commit = import.meta.env.VITE_COMMIT_SHA
  return commit ? `dev-${commit.slice(0, 7)}` : 'dev'
}
